import PropTypes from 'prop-types';
// material
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};


export default function Logo({ sx,img }) {
  return <Box component="img" src={img} sx={{ width: "70%", ...sx }} />;
}



